// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#cz2.cz2 .cz2__ai-modal .cz2__ai-modal-beta{border-radius:8px;padding:4px 8px;background-color:#eaeaea;color:#000;font-size:12px;font-family:Proxima Nova,sans-serif;font-weight:700}#cz2.cz2 .cz2__ai-modal .cz2__ai-modal-beta.cz2__in-button{position:static;margin-right:-46px;margin-left:6px;background-color:hsla(0,0%,100%,.8);font-size:10px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
